import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SiteFooter from './SiteFooter';

/**
 * Shared premium layout for legal / agreement pages.
 *
 * Structure (official YOVAI business document feel):
 *   - Minimal top nav ("Back To Home" link only)
 *   - Centered document header:
 *       [YOVAI logo]
 *       YOVAI LLC
 *       [Document Title]
 *       Effective Date: ...
 *       ────
 *   - Content
 *   - ────
 *   - YOVAI LLC / Georgia, United States / www.yovaiagency.com
 *   - Site footer
 */
const LegalLayout = ({ title, effectiveDate, children }) => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="landing-page">
      <div className="ambient-bg" />
      <div className="grain" />

      {/* Minimal nav (Back To Home only - logo lives in the document header) */}
      <nav className="site-nav legal-nav">
        <div className="site-nav-inner">
          <Link to="/" className="nav-link legal-back" data-testid="legal-back-home">
            <ArrowLeft className="inline w-4 h-4 mr-1" /> Back To Home
          </Link>
        </div>
      </nav>

      <main className="legal-wrap">
        <div className="legal-inner">
          {/* Official document header — centered logo + entity + title + date */}
          <header className="legal-doc-header">
            <img
              src="/yovai-logo.png"
              alt="YOVAI"
              className="legal-doc-logo"
              data-testid="legal-doc-logo"
            />
            <div className="legal-entity">YOVAI LLC</div>
            <h1 className="legal-title" data-testid="legal-doc-title">{title}</h1>
            {effectiveDate && (
              <p className="legal-effective" data-testid="legal-doc-effective">
                Effective Date: {effectiveDate}
              </p>
            )}
            <div className="legal-divider" />
          </header>

          {children}

          {/* Official closing block */}
          <footer className="legal-doc-close">
            <div className="legal-divider legal-divider--close" />
            <div className="legal-doc-close-body">
              <div className="legal-doc-close-name">YOVAI LLC</div>
              <div>Georgia, United States</div>
              <div>
                <a href="https://www.yovaiagency.com">www.yovaiagency.com</a>
              </div>
            </div>
          </footer>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
};

export const Section = ({ title, children }) => (
  <section className="legal-section">
    {title && <h2 className="legal-h2">{title}</h2>}
    <div className="legal-body">{children}</div>
  </section>
);

export default LegalLayout;
